import Message from "../models/Messages";
import request from "../shared/http";
import appConfig from "../shared/js/app-config";

class MessageTemplateService {
    parse(item) {
        console.log('item', item);
        
        return {
            id: item.id,
            templateName: item.template_name,
            category: item.template_type,
            body: item.body,
            copyCodeLabel: item.copy_code,
            ctaButtons: item.buttons,
            footer: item.footer,
            headerText: item.header,
            headerMedia: item.media_id,
            headerMediaType: item.media_type,
            language: item.language,
            variableSamples: item.variable_sample,
            status: item.status,
            updatedAt: item.updated_at,
            createdAt: item.created_at,
            updateAt: item.updated_at,
            mediaUrl: item.media_url,
            headerType: item.header_type,
        }
    }

    async createMessageTemplate(messageData) {
        
        if (messageData.headerMediaFile) {
            const result = await this.uploadMediaNode(messageData.headerMediaFile);
            console.log('result', result);
            messageData.mediaId = result.data[0].id;
            messageData.mediaUrl = result.data[0].url;
            messageData.mediaType = result.data[0].type;
            messageData.fileType = result.data[0].fileType;
        }
        console.log('messageData', messageData);
        const url = `/message/template/${appConfig.getServiceId()}`;
        const { data } = await request.post(url, messageData);
        return data;
    }
    async getAllTemplates() {
        const url = `/message/templates/${appConfig.getServiceId()}`;
        const { data } = await request.get(url);
        return data.map((model) => new Message(this.parse(model)));
    }
    async uploadMediaNode(file) {
    console.log("servicefile", file);
    const formData = new FormData();
    formData.append("files", file);
    formData.append("name", file.name);
    formData.append("type", file.type);
    formData.append("service_id", appConfig.getServiceId());
    console.log("formData", formData);

    try {
      const response = await request.post(
        `/upload-media/${appConfig.getServiceId()}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log(`Media uploaded successfully:`, response);
      return response;
    } catch (error) {
      console.error(`Error uploading media:`, error);
      throw error;
    }
  }
}
export default new MessageTemplateService();